import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { DatabaseUser } from 'src/modules/database/shared/database-user.entity';
import { AdminBaseEditComponent } from 'src/modules/sm-base/components/admin-base-edit/admin-base-edit.component';
import { FrontendField } from 'src/modules/sm-base/netgen/FrontendField';
import { FrontendFieldListItem } from 'src/modules/sm-base/netgen/FrontendFieldListItem';
import { FrontendFieldType } from 'src/modules/sm-base/netgen/FrontendFieldType';
import { FrontendForm } from 'src/modules/sm-base/netgen/FrontendForm';
import { ProjectPlanningTools } from '../../models/project-planning-tools.model';
import { CalendarRole } from '../../netgen/CalendarRole';
import { ProjectPlanningService } from '../../services/project-planning.service';
import { Utils } from 'src/modules/utils/shared/utils';

@Component({
    selector: 'app-edit-calendar-role',
    templateUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.html',
    styleUrl: '../../../sm-base/components/admin-base-edit/admin-base-edit.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditCalendarRoleComponent extends AdminBaseEditComponent<CalendarRole> {

    service = inject(ProjectPlanningService);
    
    definition = ProjectPlanningTools.definitionCalendarRole;

    users: DatabaseUser[];
    
    async initAdditionalData(): Promise<void> {
        this.users = await this.service.getActiveUsers();
    }

    getForm(): FrontendForm {
        return this.app.tForm("entity.CalendarRole.fields", new FrontendForm([
            new FrontendField("title", "", FrontendFieldType.string, { mandatory: true }),
            new FrontendField("mail", "", FrontendFieldType.string),
            new FrontendField("color", "", FrontendFieldType.color, { predefinedColors: Utils.getMaterialColors()}),                  
            new FrontendField("responsibleId", "", FrontendFieldType.dropdown, {
                mandatory: true, 
                listItems: FrontendFieldListItem.make(this.users, item => [item.id, item.getFullName()]),
                dropdownCanFilter: true,
                emptyValues: [null, undefined, 0]
            })               
        ]));
    }
    
}
